import * as angular from "angular";
import {IController} from "angular";

export class PlanningRoutePackagesTooltipCtrl implements IController {
  packageList: any;
  isPacked: any;
  packedDate: any;

  constructor() {
  }
}


angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutePackagesTooltip', {
    bindings: {
      packageList: '<',
      isPacked: '<',
      packedDate: '<'
    },
    template: require('./planning-route-packages-tooltip.html').default,
    controller: PlanningRoutePackagesTooltipCtrl
  });
